export default "__VITE_ASSET__CmI_XnHu__"